import {CustomFieldSection} from './CustomFieldSection';
import {t} from 'i18next';
import {CustomInfo, ICustomInfoProps} from './CustomInfo';
import {
  getUTCDateTimeForDisplay,
  isEmpty,
} from '../../../../utils/utils';
import {useMemo} from 'react';

export interface IFieldCategoryActivityProps {
  createdBy: string;
  createdOn: string;
  updatedBy?: string;
  updatedOn?: string;
  editModeParamKey?: string;
  disabled?: boolean;
}

const FieldCategoryActivity: React.FC<IFieldCategoryActivityProps> = ({
  createdOn,
  createdBy,
  updatedOn,
  updatedBy,
  editModeParamKey = '',
  disabled = false,
}) => {
  const values: ICustomInfoProps = useMemo(() => {
    const value1 = {
      title: t('fieldManagement.customField.activityMeta.createdOn'),
      value: getUTCDateTimeForDisplay(createdOn ? createdOn : new Date()),
      isDate: true,
    };
    const value2 = {
      title: t('fieldManagement.customField.activityMeta.createdBy'),
      value: createdBy,
    };
    let value3, value4;

    if (updatedOn) {
      value3 = {
        title: t('fieldManagement.customField.activityMeta.lastModifiedOn'),
        value: getUTCDateTimeForDisplay(updatedOn ? updatedOn : new Date()),
        isDate: true,
      };
    }
    let updatedByValue = updatedBy;
    if (isEmpty(updatedBy) && !isEmpty(updatedOn) && !isEmpty(createdBy)) {
      updatedByValue = createdBy;
    }
    if (updatedByValue) {
      value4 = {
        title: t('fieldManagement.customField.activityMeta.lastModifiedBy'),
        value: updatedByValue,
      };
    }

    return {
      value1,
      value2,
      value3,
      value4,
    };
  }, [createdOn, createdBy, updatedOn, updatedBy]);
  return (
    <CustomFieldSection title={t('fieldManagement.customField.activity')}>
      <CustomInfo
        {...values}
        editModeParamKey={editModeParamKey}
        disabled={disabled}
      />
    </CustomFieldSection>
  );
};

export {FieldCategoryActivity};
